var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21219 25.7378V14.5918H12.9292L13.6358 9.98099H9.21219V6.98909C9.21219 5.7277 9.82987 4.49822 11.8113 4.49822H13.823V0.57308C13.823 0.57308 11.9976 0.261719 10.2528 0.261719C6.60969 0.261719 4.22792 2.46978 4.22792 6.46709V9.98099H0.177734V14.5918H4.22792V25.7378H9.21219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.323 3.99822H11.8113C10.712 3.99822 9.90916 4.34375 9.39049 4.9436C8.88354 5.5299 8.71219 6.28576 8.71219 6.98909V9.98099V10.481H9.21219H13.0534L12.5 14.0918H9.21219H8.71219V14.5918V25.2378H4.72792V14.5918V14.0918H4.22792H0.677734V10.481H4.22792H4.72792V9.98099V6.46709C4.72792 4.56825 5.29158 3.15589 6.2279 2.21882C7.16473 1.28124 8.5323 0.761719 10.2528 0.761719C11.0986 0.761719 11.9703 0.837395 12.6349 0.914102C12.9055 0.945337 13.1403 0.976558 13.323 1.00252V3.99822Z",
    stroke: "white",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.3d2e03fc4fce13a0ff9db1a1e5a7046f.svg";
export { ForwardRef as ReactComponent };